export default __webpack_public_path__ + "static/media/DDD-Centre-of-Excellence-(CoE).77370d5d.png";